
<div *ngIf="aiData">

    <div ngbAccordion class="addinfo-accordion" *ngFor="let group of aiData; let i = index">

        <div ngbAccordionItem="panel-1" [collapsed]="false">

            <div ngbAccordionHeader>
                <button ngbAccordionButton type="button" class="btn-accordion-title">
                    <div class="d-flex justify-content-between w-100">
                        <div>{{ group.attribute_group_name | uppercase }}</div>
                        <div><i class="bi bi-chevron-right"></i></div>
                    </div>
                </button>
            </div>

            <div ngbAccordionCollapse>
              <div ngbAccordionBody>
                <ng-template>

                <div class="row content" *ngFor="let attr of group.attributes; let j = index">

                    <!-- attribute_name -->
                    <div class="col-4 content-attribute-name">{{ attr.attribute_name }}:</div>

                    <!-- attribute_value -->

                    <!-- IF INPUT -->
                    <div class="col-8 content-attribute-value" *ngIf="attr.attribute_type == attrType.input">
                        <span *ngIf="!attr.translation">{{ attr.attribute_value }}</span>
                        <span *ngIf="attr.translation">{{ attr.attribute_value.ru }}</span>
                    </div>
                    
                    <!-- IF TEXTAREA -->
                    <div class="col-8 content-attribute-value" *ngIf="attr.attribute_type == attrType.textarea">
                        <span *ngIf="!attr.translation">{{ attr.attribute_value }}</span>
                        <span *ngIf="attr.translation">{{ attr.attribute_value.ru }}</span>
                    </div>

                    <!-- IF COMBOBOX (select)-->
                    <div class="col-8 content-attribute-value" *ngIf="attr.attribute_type == attrType.combobox">
                        <span>{{ getAttrValueQuery(attr.attribute_value, attr.value_query) }}</span>
                    </div>

                    <!-- IF COMBOBOX_MULTIPLE (select)-->
                    <div class="col-8 content-attribute-value" *ngIf="attr.attribute_type == attrType.combobox_multiple">
                        <span>{{ getAttrValueQuery(attr.attribute_value, attr.value_query, 'multiple') }}</span>
                    </div>

                    <!-- IF FILE -->
                    <div class="col-8 content-attribute-value" *ngIf="attr.attribute_type == attrType.file">
                        <div *ngFor="let file of attr.files">
                            <a (click)="downloadFile(file)" ngbTooltip="{{ 'DOWNLOAD_FILE' | translate }}" class="el-card-link">
                                {{ file.name }}
                            </a>
                        </div>
                    </div>

                    <!-- IF TAG -->
                    <div class="col-8 content-attribute-value" *ngIf="attr.attribute_type == attrType.tags">
                        <div *ngFor="let tag of attr.tags">
                            <div class="tag-box">
                                <div class="tag-box">
                                    <div *ngIf="tag.graphics_visible" [ngStyle]="getTagStyle(tag.tag_size_detail)">
                                        <div [innerHTML]="tag.tagHtml" [color]="tag.color"></div>
                                    </div>
                                    <div *ngIf="tag.text_visible" [ngStyle]="{'color': tag.font_color}">
                                        {{tag.name}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- IF SERTIFICATE -->
                    <div class="col-8 content-attribute-value" *ngIf="attr.attribute_type == attrType.certificate">
                        <ul *ngIf="attr.attribute_value">
                            <li>{{ 'VALID_FORM' | translate }}:  {{ attr.certificate.valid_from | date: 'dd.MM.yyyy HH:mm'}}</li>
                            <li>{{ 'VALID_UNTIL' | translate }}: {{ attr.certificate.valid_to | date: 'dd.MM.yyyy HH:mm' }}</li>
                            <li>
                                <div *ngIf="attr.certificate.file.length > 0">
                                    <a (click)="downloadFile(attr.certificate.file[0])" ngbTooltip="{{ 'DOWNLOAD_FILE' | translate }}" class="el-card-link">
                                        {{ attr.certificate.file[0].name }}
                                    </a>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

                </ng-template>
              </div>
            </div>

        </div>

    </div>

</div>